export const cleanupImageSrc = (src: string): string | undefined => {
    if (src) {
        if (!src.startsWith('http')) {
            return `https://s3.tractorzoom.com/${src}`;
        }

        return src.replace('tz-prod.s3.amazonaws.com', 's3.tractorzoom.com');
    }

    return undefined;
};

export const getAuctioneerLogo = (logo) =>
    logo ? (logo.startsWith('http') ? cleanupImageSrc(logo) : `https://tz-production.gumlet.io/${logo}`) : undefined;
